(function () {
  'use strict';

  const component = document.querySelector('.product-page-free-shipping-countdown');

  if (!component) {
    return;
  }

  const cutoffTime = parseTime(component.dataset.sameDayDeliveryCutoffTime);
  const countdownStartTime = parseTime(component.dataset.countdownStartTime);

  const timeLeft = document.createElement('span');
  timeLeft.classList.add('product-page-free-shipping-countdown-timer');

  clearChildNodes(component);
  component.appendChild(document.createTextNode('Order in the next '));
  component.appendChild(timeLeft);
  component.appendChild(document.createTextNode(' to deliver for FREE today'));

  updateTimer();

  function updateTimer() {
    const now = new Date();
    const startTime = new Date();
    startTime.setHours(countdownStartTime.hour, countdownStartTime.minute, 0, 0);
    const endTime = new Date();
    endTime.setHours(cutoffTime.hour, cutoffTime.minute, 0, 0);

    if (now < startTime) {
      clearChildNodes(component);
      component.textContent = 'Free same-day delivery';
      return;
    } else if (now >= startTime && endTime - now > 60 * 1000) {
      // Do nothing
    } else {
      clearChildNodes(component);
      component.textContent = 'Free next-day delivery';
      return;
    }

    let timeLeftStr = '';
    const minutesLeft = Math.floor((endTime - now) / 1000 / 60);

    if (minutesLeft < 60) {
      timeLeftStr = `${minutesLeft} minute${minutesLeft > 1 ? 's' : ''}`;

      const nextMinute = new Date(now.valueOf());
      nextMinute.setMinutes(now.getMinutes() + 1, 0, 0);
      setTimeout(updateTimer, nextMinute - now);
    } else {
      const hoursLeft = Math.floor(minutesLeft / 60);
      timeLeftStr = `${hoursLeft} hour${hoursLeft > 1 ? 's' : ''}`;

      const nextHour = new Date(now.valueOf());
      nextHour.setHours(now.getHours() + 1, 0, 0, 0);
      setTimeout(updateTimer, nextHour - now);
    }
    
    timeLeft.textContent = timeLeftStr;
  }

  function clearChildNodes(node) {
    while (node.hasChildNodes()) {
      node.removeChild(node.lastChild);
    }
  }

  function parseTime(timeStr) {
    timeStr = timeStr.toUpperCase();

    const tokens = timeStr.split(/[: ]/);

    if (tokens.length !== 3) {
      throw new Error('Invalid time format');
    }

    let hour = parseInt(tokens[0], 10);
    const minute = parseInt(tokens[1], 10);
    const period = tokens[2];

    if (hour < 1 || hour > 12) {
      throw new Error('Invalid time format');
    }

    if (minute < 0 || minute > 59) {
      throw new Error('Invalid time format');
    }

    if (period !== 'AM' && period !== 'PM') {
      throw new Error('Invalid time format');
    }

    if (period === 'PM') {
      if (hour !== 12) {
        hour += 12;
      }
    } else {
      if (hour === 12) {
        hour = 0;
      }
    }

    return { hour, minute };
  }
})();